import React from 'react';
import { IChildConnectionDTO } from '../../../../../../api/connections.dao';
import TextWithCopyBtn from '../../connections-list/_text-with-copy-btn/text-with-copy-btn';
import { childConnectionDetailsLabels } from '../../../../../../constants/connections-labels.constants';

type UniqueDialInDetailsProps = {
    childConnection: IChildConnectionDTO;
    onCopyBtnClick: () => void;
};

export const UniqueDialInDetails = (props: UniqueDialInDetailsProps): JSX.Element => {
    const { childConnection, onCopyBtnClick } = props;
    const { attendeeId, attendeeEmail, uniqueDialInCode, conferenceId, userId } = childConnection;
    const labels = childConnectionDetailsLabels();

    return (
        <>
            {attendeeId && (
                <div className='connection-list__field'>
                    OEC {labels.ATTENDEE_ID()}:<br />
                    <TextWithCopyBtn message={String(attendeeId)} handleCopyClick={onCopyBtnClick} />
                </div>
            )}
            {attendeeEmail && (
                <div className='connection-list__field'>
                    {labels.ATTENDEE_EMAIL()}:<br />
                    <TextWithCopyBtn message={attendeeEmail} handleCopyClick={onCopyBtnClick} />
                </div>
            )}
            {uniqueDialInCode && (
                <div className='connection-list__field'>
                    {labels.PARTICIPANT_ID()}:<br />
                    <TextWithCopyBtn message={uniqueDialInCode} handleCopyClick={onCopyBtnClick} />
                </div>
            )}
            {conferenceId && (
                <div className='connection-list__field'>
                    {labels.CONFERENCE_ID()}:<br />
                    <TextWithCopyBtn message={conferenceId} handleCopyClick={onCopyBtnClick} />
                </div>
            )}
            {userId && (
                <div className='connection-list__field'>
                    {labels.USER_ID()}:<br />
                    <TextWithCopyBtn message={userId} handleCopyClick={onCopyBtnClick} />
                </div>
            )}
        </>
    );
};
